import React from "react";
import ga from "react-ga";

export default React.createClass({
  displayName: "no-hal",
  
  render: function() {
    return (
      <div id="halDiv">
        <input type="text" ref="hal" name="hal" id="hal"/>
      </div>
    )
  }
});

export function halCheck(email, that) {
  var data = document.getElementById("hal");
  if (data.value.length !== 0) {
    ga.event({
      category: "user",
      action: "signin",
      label: "unexpexted input",
      data: "email " + email + " hal " + data.value
    });
    console.log("email " + email + " HAL! " + data.value);
    data.value = "";
    that.props.history.pushState(null, "docs");
    return true
  }
  else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/js/utilities/no-hal.jsx